module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "map__photo"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "map__map"
  }, [_c('div', {
    staticClass: "map__container",
    attrs: {
      "id": _vm.id
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08d4ae22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d4ae22","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/YandexMap.vue
// module id = 142
// module chunks = 0